import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";

@Component({
    selector: "file-upload",
    templateUrl: "./file-upload.component.html",
    styleUrls: ["file-upload.component.scss"]
})
export class FileUploadComponent {

    @ViewChild("fileInput") fileInput: any;

    @Input() fileExtension: string = ".json";
    @Input() fileType: string = "application/json";

    @Output() onConfirm: EventEmitter<any> = new EventEmitter();
    @Output() onCancel: EventEmitter<any> = new EventEmitter();

    fileContent: any;
    fileName: string;

    state: boolean = true;

    resetting: boolean = false;

    cancel(): void {
        this.onCancel.emit();
        this.state = false;
    }

    confirm(): void {
        this.onConfirm.emit(this.fileContent);
        this.state = false;
    }

    readSingleFile(event): void {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        this.loadFile(event.target.files[0]);
    }

    loadFile(file: File): void {
        if (this.fileType && file.type !== this.fileType) {
            return;
        }
        const reader: FileReader = new FileReader();
        reader.onload = (e: Event) => {
            this.fileContent = e.target["result"];
            this.fileName = file.name;
        };
        reader.readAsText(file);
    }

    dragover(event: DragEvent): void {
        event.stopPropagation();
        event.preventDefault();
    }

    drop(event: DragEvent): void {
        event.stopPropagation();
        event.preventDefault();
        if (event.dataTransfer.files && event.dataTransfer.files.length) {
            this.loadFile(event.dataTransfer.files[0]);
        }
    }

    reset(): void {
        this.fileName = undefined;
        this.fileContent = undefined;
        this.state = true;
        setTimeout(() => {
            this.resetting = true;
            setTimeout(() => this.resetting = false);
        });
    }
}
